export const projects = [
  {
    title: "Vue, Laravel and Mysql",
    subtitle: "LAMP Stack",
    description:
      "Developments of software to control the entire process of aircraft repair parts, whose performance can handle the increasing amount of daily work.",
    image: "./project-1.gif",
    link: "https://smart145.com/",
  },
  {
    title: "Sandoz - Ponentes",
    subtitle: "Jquery and Symfony",
    description: "",
    image: "./project-2.gif",
  },
  {
    title: "REagent",
    subtitle: "React, Typescript, Material UI, Laravel, AWS Amplify, AWS Cognito, AWS S3, Postgres",
    description: "",
    image: "./project-3.gif",
  },
  {
    title: "Galipor",
    subtitle: "React, React Native Expo",
    description: "Development a software to control Swine feeding",
    image: "./project-4.gif",
    link: "http://galiportdb.geg.cu/graphql",
  },
];

export const testimonials = [
  {
    quote: `Giorbis is a excelent team leader, with the ability to help through constructive criticism.
    Their experience and willingness to provide help, they allow to integrate into the work team in an easier way. He is a person who advocates and encourages professional and personal improvement, constantly,
    showing that there are no limits to continue learning.`,
    image:
      "https://media-exp1.licdn.com/dms/image/C4D03AQGHN8X7IHXULQ/profile-displayphoto-shrink_200_200/0/1558702589286?e=1631145600&v=beta&t=JWf5grf2uiXIynIkGLiVrb-axN6A6MUjoEZ6orkhRKc",
    name: "Ronny Garcia Lorenzo",
    company: "Smart145",
  },
  {
    quote: `Giorbis is a great mind. Think of things the rest of us overlook. As a result, he has led his team to discover new ideas and to sow the spirit of creativity in each one of us. He quickly assumes new responsibilities while having time to teach and share his knowledge with the other team members.`,
    image:
      "https://media-exp1.licdn.com/dms/image/C4D03AQE86R1gnKOm9w/profile-displayphoto-shrink_200_200/0/1552401381051?e=1631145600&v=beta&t=n203NfDmnPgTCZyUBoM7M95orYpiIY5N-9I8wuA_9XE",
    name: "José Carlos",
    company: "Smart145",
  },
];

export const skills = [
  "HTML5",
  "CSS3",
  "Boostrap",
  "JavaScript (ES5 and ES6)",
  "Tailwindcss",
  "Ant Design",
  "Material UI",
  "Cypress",
  "TDD",
  "ReactJs",
  "NextJs",
  "NestJs",
  "React Native",
  "Flutter",
  "Vue",
  "NuxtJs",
  "Django",
  "Postgres",
  "Laravel",
  "Mysql",
  "AWS",
];



// WEBPACK FOOTER //
// ./src/data.js